import { makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) => ({
  paperContent: {
    
  },
  searchInput: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    ...CommonFonts.darkFont18,
  },
  addButton: {
    height: 52,
    padding: theme.spacing(2.5, 0),
    background: '#1174F2 0% 0% no-repeat padding-box',
    textTransform: 'Uppercase',
    ...CommonFonts.whiteFont14,
  },
  emptyAddonsText: {
    ...CommonFonts.darkFont18,
  },
  disableTextTransform: {
    textTransform: 'none'
  },
  menuItem: { 
    height: 60, 
    color: '#20272FDE', 
    fontSize: 18 
  },
}));

export default useStyles;
